import { Link } from "react-router-dom";
import ContactsContacts from "./components/contacts";
import ContactsGroups from "./components/groups";
import ContactsNotifications from "./components/notifications";

const Contacts = ({ page }: IContactsProps) => {
  const menu = [
    {
      id: "ContactsContacts",
      slug: "/contacts",
      title: "Contacts",
    },
    {
      id: "ContactsGroups",
      slug: "/contacts/groups",
      title: "Groups",
    },
    {
      id: "ContactsNotifications",
      slug: "/contacts/notifications",
      title: "Notifications", 
    },
  ];

  return (
    <main className="container mx-auto py-16 mb-auto">
      <ul className="flex justify-start">
        {menu.map((item) => (
          <li key={item.id} className="me-8 text-sans pb-2">
            <Link
              to={item.slug}
              className={`border-b-4 pb-2 ${
                item.id === page?.type.name
                  ? "text-gray-800 border-text-link"
                  : "text-gray-400 border-transparent"
              }`}
            >
              {item.title}
            </Link>
          </li>
        ))}
      </ul>
      <div className="w-full border-t border-gray-300 py-4">{page}</div>
    </main>
  );
};

interface IContactsProps {
  page?: JSX.Element;
}

export { Contacts, ContactsContacts, ContactsGroups, ContactsNotifications };
